import {
    validateAddress,
    validateEmail,
    validatePhone,
    validateInternationalPostalCode
} from '../Shared/validations.js';
import { copyFor } from '../../copy/copy';

const validateFullName = values => {
    if (!values) return;
    if (!values.fullName) {
        return { fullName: copyFor('validationErrors', 'fullName', 'petition') };
    }
    const split = values.fullName.split(' ');

    if (split.length > 1 && split[0] !== '' && split[1] !== '') return {};

    return { fullName: copyFor('validationErrors', 'fullName', 'petition') };
};

const validateMessage = values => {
    if (!values) return;
    if (!values.message) {
        return { message: copyFor('validationErrors', 'message', 'petition') };
    }
    return {};
};

const validate = values => {
    let errors = {
        ...validateFullName(values),
        ...validateEmail(values)
    };

    if (values) {
        if (Object.keys(values).includes('address')) {
            errors = {
                ...errors,
                ...validateAddress(values)
            };
        }
        if (Object.keys(values).includes('phone')) {
            errors = {
                ...errors,
                ...validatePhone(values)
            };
        }
        if (Object.keys(values).includes('postalCode')) {
            errors = {
                ...errors,
                ...validateInternationalPostalCode(values)
            };
        }
        if (Object.keys(values).includes('message')) {
            errors = {
                ...errors,
                ...validateMessage(values)
            };
        }
    }

    return errors;
};

export default validate;
